document.documentElement.classList.remove('no-js');

if(window.matchMedia("(pointer: coarse)").matches) {
    document.documentElement.classList.remove('no-touchevents');
    document.documentElement.classList.add('has-touchevents');
}
